import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7b0537bedae70014e33c7c_1786537890435_3ce35f7a/zovadesk_myriad_1786447159201/src/app/forgot-password/page.tsx");
